<template>
  <div class="modal-mask" @click.self="close">
    <div class="modal">
      <h4>센터 검색</h4>

      <!-- 검색조건: 검색어 / 조회(청색) / 닫기 -->
      <div class="top">
        <input v-model="keyword" type="text" placeholder="검색어" @keyup.enter="search" />
        <span class="spacer"></span>
        <button class="primary" :disabled="busy" @click="search">조회</button>
        <button class="ghost" @click="close">닫기</button>
      </div>

      <!-- 표: 센터명 / 센터장 / 선택 (20003: 체크/라디오 컬럼 제거) -->
      <div class="result-box">
        <table class="grid">
          <thead>
            <tr><th>센터명</th><th>센터장</th><th class="c">선택</th></tr>
          </thead>
          <tbody>
            <tr v-for="r in rows" :key="r.id" class="pick" @click="choose(r)">
              <td>{{ r.centerName }}</td>
              <td>{{ r.leaderName || '-' }}</td>
              <td class="c"><button class="pickbtn" @click.stop="choose(r)">선택</button></td>
            </tr>
            <tr v-if="rows.length===0"><td colspan="3" class="empty">검색 결과가 없습니다.</td></tr>
          </tbody>
        </table>
      </div>

      <Paging v-if="total > 0" :page="page" :size="size" :total-count="total" :total-pages="totalPages"
              @change-page="onPage" @change-size="onSize" />
      <p v-if="message" class="error">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import api from '../api';
import Paging from './Paging.vue';

export default {
  name: 'SettlementCenterSearchDialog',
  components: { Paging },
  // selfChildrenOnly=true: "그 외 화면에서 진입"(customer 는 자신의 자식/소속만) 케이스
  props: { selfChildrenOnly: { type: Boolean, default: false } },
  data() { return { keyword: '', rows: [], selected: null, busy: false, message: '', page: 1, size: 10, total: 0 }; },
  computed: { totalPages() { return Math.max(1, Math.ceil(this.total / this.size)); } },
  created() { this.load(); },   // 진입 시 자동 조회(초기 로드는 2자 제한 미적용)
  methods: {
    async search() {
      // 20006: 조회 시 검색어 2자 이상 필수
      if (!this.keyword || this.keyword.trim().length < 2) { this.message = '검색어를 2자 이상 입력하세요.'; return; }
      this.busy = true; this.message = ''; this.page = 1; this.selected = null;
      await this.load();
      this.busy = false;
    },
    async load() {
      try {
        const res = await api.searchCenterPopup({
          keyword: this.keyword, selfChildrenOnly: this.selfChildrenOnly, page: this.page, size: this.size
        });
        const d = res.data || {};
        this.rows = d.rows || [];
        this.total = d.total || 0;
      } catch (e) { this.message = e.message; this.rows = []; this.total = 0; }
    },
    onPage(p) { this.page = p; this.load(); },
    onSize(s) { this.size = s; this.page = 1; this.load(); },
    choose(r) { this.$emit('select', r); },
    close() { this.$emit('close'); }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 80; }
.modal { background: #fff; padding: 22px; border-radius: 8px; width: 760px; max-width: 96vw; }
.modal h4 { margin: 0 0 12px; }
.top { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.top input { padding: 7px 9px; border: 1px solid #d0d5dd; border-radius: 5px; flex: 0 0 220px; }
.top .spacer { flex: 1; }
.top button { padding: 7px 14px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; }
.top .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.top .ghost { background: #f5f5f5; }
.result-box { max-height: 320px; overflow: auto; border: 1px solid #eef; border-radius: 6px; }
.grid { width: 100%; border-collapse: collapse; }
.grid th, .grid td { border-bottom: 1px solid #eef; padding: 7px 9px; font-size: 13px; text-align: left; }
.grid th.c, .grid td.c { text-align: center; }
.grid th { background: #f0f3fa; position: sticky; top: 0; }
.grid tr.pick { cursor: pointer; }
.grid tr.sel { background: #eaf1ff; }
.grid tr:hover { background: #f6f9ff; cursor: pointer; }
.pickbtn { padding: 3px 10px; border: 1px solid #2f6fed; background: #eef4ff; color: #2f5fd0; border-radius: 5px; cursor: pointer; font-size: 12px; }
.empty { text-align: center; color: #999; padding: 14px; }
.error { font-size: 13px; color: #d93636; margin: 8px 0 0; }
</style>
